import { Link } from 'react-router-dom';
import { closingCta, contact } from '../../../content/agencyCopy';
import RevealOnScroll from '../RevealOnScroll';
import SignalCta from '../SignalCta';

export default function ClosingCTA() {
  return (
    <section
      className="px-6 py-28 md:py-36"
      style={{ background: 'var(--fa-paper)' }}
    >
      <RevealOnScroll className="max-w-[1120px] mx-auto">
        <h2
          className="font-display text-[36px] md:text-[52px]"
          style={{ maxWidth: '14ch' }}
        >
          {closingCta.headline}
        </h2>
        <p
          className="mt-6 text-[16px] md:text-[17px] fa-glow-text"
          style={{ maxWidth: '60ch' }}
        >
          {closingCta.body}
        </p>
        <div className="mt-10 flex flex-wrap items-center gap-4">
          <SignalCta
            data-cal-link={contact.calLink}
            data-cal-namespace={contact.calNamespace}
          >
            {closingCta.cta}
          </SignalCta>
          <SignalCta to={closingCta.assessHref} variant="ghost">
            {closingCta.assessCtaLabel}
          </SignalCta>
        </div>
        <div className="mt-6">
          <a
            href={contact.whatsappHref}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 text-[14px] transition-colors hover:opacity-80"
            style={{ color: 'var(--fa-muted)' }}
          >
            {contact.whatsappSecondaryLabel}
            <span aria-hidden="true" style={{ color: 'var(--fa-signal)' }}>→</span>
          </a>
        </div>
      </RevealOnScroll>
    </section>
  );
}
